import React from 'react';
import workspaceQuery from './PromotionalMessageWorkspaceQuery.graphql';
import listQuery from './PromotionalMessageListQuery.graphql';
import instanceQuery from './PromotionalMessageQuery.graphql';
import defaultQuery from './PromotionalMessageDefault.graphql';
import mutationQuery from './PromotionalMessageMutation.graphql';
import temporaryUpdateQuery from './PromotionalMessageTempMutation.graphql';
import fragment from './PromotionalMessageFragment.graphql';
import { EntityType, IDropdownOptionRenderer } from '../../../../@types/entityTypes';
import { IPromotionalMessage } from '../../../schema/p4types';

const PromotionalMessageOptionRenderer: IDropdownOptionRenderer = ({ option }: { option: IPromotionalMessage }) => {
  return <span>{option.name}</span>;
};

const PromotionalMessage: EntityType = {
  type: 'PromotionalMessage',
  title: 'Promotional Messages',
  formTitle: 'Promotional Message',
  formUrl: '/Products/PromotionalMessage/Details/',
  workspaceUrl: '/Products/PromotionalMessage/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporaryUpdate: temporaryUpdateQuery,
  notificationKey: 'reference',
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
    optionRenderer: PromotionalMessageOptionRenderer,
    filterOption: () => true,
    remoteFilter: true,
    placeholder: 'Search Promotional Messages',
    pageView: false,
    asButton: false,
  },
  fragment,
  screenReference: 'PROMOTIONAL_MESSAGES',
};

export default PromotionalMessage;
